import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PaginationforUmbrallaProjectRecent from "./PaginationforUmbrallaProjectRecent";
import PaginationforUmbrallaProjectActive from "./PaginationforUmbrallaProjectActive";
import PaginationforUmbrallaProjectCompleted from "./PaginationforUmbrallaProjectCompleted";
import PaginationforUmbrallaProjectCancelled from "./PaginationforUmbrallaProjectCancelled";

export default function PaginationUmbrallaProject() {
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [activeTab, setActiveTab] = useState("paymentpending"); // State to track active tab
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    dispatch(getPostCounts(2));
  }, [dispatch]);

  return (
    <>
      <div className="order-section manage-project">
        <div className="tab-sec">
          <div className="order-first">
            <h2>My Orders</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("paymentpending")}
                  className={`nav-link ${activeTab == "paymentpending" ? "active" : ""}`}
                >
                  Recent Posted Umbrella Post & Browse Projects (PBP) (
                  {postcounts?.posted_orders?.recent_umbrella_project || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("applied")}
                  className={`nav-link ${activeTab == "applied" ? "active" : ""}`}
                >
                  Active Umbrella Post & Browse Projects (PBP) (
                  {postcounts?.posted_orders?.umbrella_project || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("active")}
                  className={`nav-link ${activeTab == "active" ? "active" : ""}`}
                >
                  Completed Umbrella Post & Browse Projects (PBP) (
                  {postcounts?.completed_orders?.umbrella_project || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Cancelled")}
                  className={`nav-link ${activeTab == "Cancelled" ? "active" : ""}`}
                >
                  Cancelled Umbrella Post & Browse Projects (PBP) (
                  {postcounts?.cancelled_orders?.umbrella_project || 0})
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {activeTab == "paymentpending" && (
              <div className="tab-pane active" id="paymentpending">
                <PaginationforUmbrallaProjectRecent />
              </div>
            )}
            {activeTab == "applied" && (
              <div className="tab-pane active" id="applied">
                <PaginationforUmbrallaProjectActive />
              </div>
            )}
            {activeTab == "active" && (
              <div className="tab-pane active" id="active">
                <PaginationforUmbrallaProjectCompleted />
              </div>
            )}
            {activeTab == "Cancelled" && (
              <div className="tab-pane active" id="Cancelled">
                <PaginationforUmbrallaProjectCancelled />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
